export function runMockBootstrap(
  enableMocks: () => Promise<void>,
  renderApp: () => void,
  renderStartupError: (error: unknown) => void,
): Promise<void> {
  return enableMocks().then(renderApp).catch(renderStartupError)
}
